"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortfolioGeneratedLoanTapeNormalizedBaseFieldsSchema = void 0;
const zod_1 = require("zod");
// Note: externalReceivableId and finleyReceivableId are not included in normalized base fields here,
// those properties are attached to the data structure through BBPL tasks, and flattened into the data lake upload
// by default.
// Zod schema for PortfolioGeneratedLoanTapeNormalizedBaseFields
exports.PortfolioGeneratedLoanTapeNormalizedBaseFieldsSchema = zod_1.z.object({
    borrowerKey: zod_1.z.string(), // organization.borrowerKey of abstract borrower
    borrowerId: zod_1.z.string(), // mapped column from baseFields
    creditFacilityKey: zod_1.z.string(), // creditFacility.slug of the abstract credit facility
    creditFacilityId: zod_1.z.string(), // mapped column from baseFields, or dynamically created if 1:1 with borrower
    loanProductKey: zod_1.z.string(), // loanProduct.slug of the abstract loan product
    loanProductId: zod_1.z.string(), // mapped column from baseFields, or dynamically created with borrowerKey+loanProductKey
});
//# sourceMappingURL=PortfolioGeneratedLoanTape.js.map